'use client';

import { useEffect } from 'react';
import { syncSeenArticlesToCookie, trackSeenArticle } from '@/app_lib/services/recommendations/seenArticles';

interface TrackSeenArticleProps {
  articleId: string;
}

export const TrackSeenArticle = ({ articleId }: TrackSeenArticleProps) => {
  useEffect(() => {
    trackSeenArticle(articleId);
    syncSeenArticlesToCookie();
  }, [articleId]);

  return null;
};
